import classNames from 'classnames';
import { BEMBlock } from 'helpers/classnames';
import { Icon, IconName } from 'palette/Icon';
import { Small } from 'palette/Typography';
import { TagTheme, TAG_FONT_COLORS_BY_THEME } from './constants';

import './Tag.scss';

export interface TagProps {
    theme: TagTheme;
    label: string | number;
    className?: string;
    icon?: IconName;
    iconPosition?: string;
}

export function Tag({
    theme = 'positive',
    icon,
    iconPosition = 'left',
    className,
    label,
}: TagProps) {
    const [block, BemElement] = BEMBlock('palette-tag', {
        [`theme-${theme}`]: theme !== undefined,
        [`icon-position-${iconPosition}`]: iconPosition,
    });
    return (
        <Small
            className={classNames(block, className)}
            color={TAG_FONT_COLORS_BY_THEME[theme]}
            level="1"
        >
            {icon && (
                <Icon
                    className={BemElement('icon', { position: iconPosition })}
                    name={icon}
                    size="x-small"
                />
            )}
            {label}
        </Small>
    );
}
